import Vue from 'vue'
import { ToastPlugin, ModalPlugin, BootstrapVue } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'


import "fullcalendar/dist/fullcalendar.min.css";

// Vue.use(FullCalendar);

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@core/scss/vue/libs/vue-select.scss'

import '@/libs/flatpickr'
// BSV Plugin Registration
Vue.use(BootstrapVue)
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

// Interceptor para agregar el token a las llamadas al API
import '@/api/interceptors/JwtToken'

//Complements
import './libs/veevalidate'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
